module.exports = __webpack_public_path__ + "static/media/win.daf00eca.mp3";